var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio',{ref:"audio",attrs:{"src":_vm.src,"preload":"auto"},on:{"timeupdate":_vm.checkAudioLoop}})}
var staticRenderFns = []

export { render, staticRenderFns }